const prefix = '[Units]';

export class LoadUnits {
    static readonly type = `${prefix} Load`;
    constructor(public readonly payload = { pageSize: 20 }) {}
}

export class LoadMoreUnits {
    static readonly type = `${prefix} Load More`;
}

export class LoadAllUnits {
    static readonly type = `${prefix} Load All`;
}
